module.exports = ".axis line {\n    stroke: #DEDEDE;\n}\n\n\n.axis path {\n    stroke: #DEDEDE;\n}\n\n\n.axis text {\n    fill: #DEDEDE;\n}\n\n\n.image-container {\n    margin: 3% 7% 2% 7%;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/shot-image/d3-image/d3-image.component.css
// module id = ./src/app/projects/project/shot-image/d3-image/d3-image.component.css
// module chunks = main